import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { useAuthProvider, useResetStore } from 'react-admin';

/**
 * Versión corregida de useLogout de react-admin.
 *
 * CORRECCIÓN: Cancela todas las queries de React Query ANTES de llamar a authProvider.logout().
 * Esto previene que las queries intenten hacer fetch después de que el token se eliminó.
 *
 * El problema original: react-admin llama a authProvider.logout() primero (que limpia localStorage),
 * y luego hace queryClient.clear() después. Esto causa que las queries que ya están en vuelo
 * o pendientes intenten hacer fetch después de que el token se eliminó, fallando con 401.
 *
 * La solución: Cancelar queries ANTES de llamar a authProvider.logout()
 */
const useLogout = (): Logout => {
    const authProvider: any = useAuthProvider();
    const queryClient = useQueryClient();
    const resetStore = useResetStore();
    const navigate = useNavigate();

    const logout: Logout = async (params = {}) => {
        // CORRECCIÓN: Cancelar todas las queries ANTES de llamar a authProvider.logout()
        // Esto previene que las queries intenten hacer fetch después de que el token se eliminó
        queryClient.cancelQueries();

        await authProvider.logout(params);
        resetStore();
        queryClient.clear();
        navigate('/login');
    };

    return logout;
};

/**
 * Log the current user out by calling the authProvider.logout() method.
 *
 * @param {Object} params The parameters to pass to the authProvider
 *
 * @return {Promise} The authProvider response
 */
type Logout = (params?: any) => Promise<any>;

export default useLogout;
